import React from 'react';
import {
  PeriodUnavailableState,
} from '../dashboardPrimitives';

export default function TowerExecutiveOverview({ selectedMonth = "Feb'26" }) {
  return <PeriodUnavailableState monthLabel={selectedMonth} />;
}
